module.exports = __webpack_public_path__ + "Naanisreeram-8cf81704.webp";